import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DesktopWindowsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"desktop_windows"}/>
}
